// extracted by mini-css-extract-plugin
export default {"fallback":"ErrorBoundary_fallback__Z6KYI","actions":"ErrorBoundary_actions__X-haa"};